const STROKE = 3;

function SvgIcon({ children, viewBox = '0 0 64 64', className = '', ...props }) {
  return (
    <svg
      className={`app-icon ${className}`.trim()}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  );
}


export function DashboardIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="7" y="8" width="50" height="42" rx="7" stroke="currentColor" strokeWidth="3.4" strokeLinejoin="round" />
      <path d="M17 36H30M17 43H27" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" />
      <path d="M38 44V33H45V44M48 44V24H55V44M28 44V38H35V44" fill="currentColor" opacity="0.9" />
      <path d="M14 29C16 20 23.4 14 32.5 14C40.6 14 47.5 19 50 26" stroke="currentColor" strokeWidth="5.2" strokeLinecap="round" />
      <path d="M32 29L48 18" stroke="currentColor" strokeWidth="3.8" strokeLinecap="round" />
      <circle cx="32" cy="29" r="3.2" fill="currentColor" />
      <path d="M18 20V18M46 20V18M11 29H15M49 29H53" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function SolarPanelDatabaseIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M14 38C9 36.5 6 32.8 6 28.2C6 22.4 10.7 17.8 16.6 17.8C18.4 10.8 24.6 6 32 6C39.4 6 45.6 10.8 47.4 17.8C53.3 17.8 58 22.4 58 28.2C58 32.8 55 36.5 50 38" stroke="currentColor" strokeWidth="3.8" strokeLinecap="round" strokeLinejoin="round" />
      <ellipse cx="32" cy="31" rx="13" ry="5.8" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="3.4" />
      <path d="M19 31V48C19 51.2 24.8 56 32 56C39.2 56 45 51.2 45 48V31" stroke="currentColor" strokeWidth="3.4" strokeLinejoin="round" />
      <path d="M19 39C19 42.2 24.8 45 32 45C39.2 45 45 42.2 45 39" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" />
      <path d="M19 48C19 51.2 24.8 54 32 54C39.2 54 45 51.2 45 48" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function SelectIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="7" y="5" width="32" height="32" rx="2" stroke="currentColor" strokeWidth={STROKE} strokeDasharray="5 5" />
      <path d="M30 23L54 46L42.5 48L38 58L30 23Z" fill="currentColor" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function RoofIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M7 38L32 15L57 38" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" strokeLinecap="round" />
      <path d="M11 39H53L47 45H17L11 39Z" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M17 39L32 25L47 39" stroke="currentColor" strokeWidth="2.3" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M32 25V45" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" />
      <path d="M25 32V45M39 32V45M21 36L32 25L43 36" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function RoofObstructionIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M13 23H51V39H13V23Z" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M16 39V52M48 39V52" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M10 52H22M42 52H54" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" />
      <path d="M15 36L29 22M23 39L40 22M34 39L51 22M13 28L19 22" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M13 17H51" stroke="currentColor" strokeWidth="2.4" strokeDasharray="5 4" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function CircleIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="32" cy="32" r="22" stroke="currentColor" strokeWidth={STROKE} />
    </SvgIcon>
  );
}

export function RectangleIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="13" y="13" width="38" height="38" fill="currentColor" opacity="0.06" stroke="currentColor" strokeWidth="4" />
    </SvgIcon>
  );
}

export function PolygonIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M23 8L48 14L53 35L39 55L17 49L8 29L23 8Z" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <circle cx="23" cy="8" r="3.5" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="48" cy="14" r="3.5" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="53" cy="35" r="3.5" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="39" cy="55" r="3.5" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="17" cy="49" r="3.5" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="8" cy="29" r="3.5" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth="2.5" />
    </SvgIcon>
  );
}

export function PropertyLineIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M5 32H59" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="16 7 4 7" />
    </SvgIcon>
  );
}


export function FireSetbackIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="32" cy="32" r="25" stroke="currentColor" strokeWidth="4.5" />
      <path
        d="M28.8 52C20.4 48.3 16 41.9 16 34.5C16 29.4 17.8 24.7 21.4 20.4C21.2 27.2 23.6 31.3 28.3 33.2C32.9 27.4 31.7 20.5 28.7 12.6C40.2 16.4 46.1 25.2 44.4 36.2C47.1 33.6 48.6 30.4 49 26.6C52.4 32.2 52.5 38.6 49.1 44C45.8 49.2 40.3 52 32 52H28.8Z"
        fill="currentColor"
      />
      <path
        d="M36.7 52C41.5 49 43.2 45.1 41.8 40.6C40.9 37.6 38.7 34.7 35.2 32C36.1 38.8 32.7 41.2 29 44.4C26.4 46.7 25.7 49.4 27.3 52H36.7Z"
        fill="var(--icon-node-fill, #fff)"
      />
      <path d="M14.2 14.2L49.8 49.8" stroke="currentColor" strokeWidth="5.2" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function SolarArrayIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M13 9H51L58 35H6L13 9Z" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M20 9L17 35M32 9V35M44 9L47 35M9 24H55M11 16H53" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M32 35V50M20 50H44M10 54H54" stroke="currentColor" strokeWidth={STROKE} strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function PortraitPanelIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="23" y="8" width="18" height="48" fill="currentColor" opacity="0.06" stroke="currentColor" strokeWidth={STROKE} />
    </SvgIcon>
  );
}

export function LandscapePanelIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="12" y="23" width="40" height="18" fill="currentColor" opacity="0.06" stroke="currentColor" strokeWidth={STROKE} />
    </SvgIcon>
  );
}

export function MapToolIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 19L22 13L36 19L51 13V48L36 55L22 49L9 55V19Z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M22 13V49M36 19V55" stroke="currentColor" strokeWidth="2" strokeDasharray="4 3" strokeLinecap="round" />
      <path d="M42 8C35 8 30 13.5 30 20.5C30 30.5 42 43 42 43C42 43 54 30.5 54 20.5C54 13.5 49 8 42 8Z" fill="currentColor" />
      <circle cx="42" cy="20.5" r="5" fill="var(--icon-node-fill, #fff)" />
    </SvgIcon>
  );
}

export function DxfIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18 5H41L55 19V54C55 57 53 59 50 59H18C15 59 13 57 13 54V10C13 7 15 5 18 5Z" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M41 5V20H55" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <rect x="7" y="29" width="41" height="20" rx="4" fill="var(--icon-node-fill, #fff)" stroke="currentColor" strokeWidth={STROKE} />
      <text x="27.5" y="43.8" textAnchor="middle" fontSize="15" fontWeight="900" fontFamily="Arial, Helvetica, sans-serif" fill="currentColor">DXF</text>
    </SvgIcon>
  );
}

export function LayersIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M32 6L55 17L32 28L9 17L32 6Z" fill="currentColor" opacity="0.12" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M13 28L32 37L51 28" fill="none" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M13 40L32 50L51 40" fill="none" stroke="currentColor" strokeWidth={STROKE} strokeLinejoin="round" />
      <path d="M17 34L32 42L47 34" fill="currentColor" opacity="0.18" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
      <path d="M17 46L32 54L47 46" fill="currentColor" opacity="0.25" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function OpenIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="10" y="18" width="36" height="36" rx="6" stroke="currentColor" strokeWidth="5" />
      <path d="M33 10H54V31" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M54 10L30 34" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function PowerIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M32 8V31" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
      <path d="M20 17.5C13 21.8 8.5 29.5 8.5 38.3C8.5 51.3 19 61 32 61C45 61 55.5 51.3 55.5 38.3C55.5 29.5 51 21.8 44 17.5" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function BackIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M38 14L20 32L38 50" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function SettingsIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="32" cy="32" r="8" stroke="currentColor" strokeWidth="4" />
      <path d="M32 7V15M32 49V57M14.3 14.3L20 20M44 44L49.7 49.7M7 32H15M49 32H57M14.3 49.7L20 44M44 20L49.7 14.3" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function SaveIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 8H44L52 16V56H12V8Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
      <path d="M20 8V24H42V8M20 56V38H44V56" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function UndoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M28 17L13 32L28 47" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 32H39C47 32 52 37 52 45" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function RedoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M36 17L51 32L36 47" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M49 32H25C17 32 12 37 12 45" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function TrashIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16 20H50M25 20V12H41V20M21 20L24 56H42L45 20" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M29 29V48M37 29V48" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function CopyIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="20" y="17" width="30" height="34" rx="4" stroke="currentColor" strokeWidth="4" />
      <path d="M14 42V13C14 10 16 8 19 8H43" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function EditIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15 45L13 55L23 53L50 26L42 18L15 45Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
      <path d="M38 22L46 30" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function CheckIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 33L26 47L53 17" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function PlusIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M32 12V52M12 32H52" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function ChevronLeftIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M38 18L24 32L38 46" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export function ChevronRightIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M26 18L40 32L26 46" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}


export function ScoreCardIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 48V34M24 48V26M38 48V18M52 48V10" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
      <path d="M8 54H56" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M11 25L24 17L37 21L52 8" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}
